import React, { useState } from 'react';
import {
    Box,
    Button,
    Container,
    Grid,
    MenuItem,
    Select,
    Typography,
    FormControl,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Modal,
    IconButton,
    TablePagination,
    Chip,
    TextField,
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DownloadIcon from '@mui/icons-material/Download';
import RefreshIcon from '@mui/icons-material/Refresh';
// import TableChartIcon from '@mui/icons-material/TableChart';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// ─── Mock Data ────────────────────────────────────────────────────────────────

const summaryCards = [
    { label: 'Total Refunds Today', value: '45', color: '#1976d2', icon: '📋' },
    { label: 'Total Amount Refunded', value: 'LKR 1,250,000.00', color: '#2e7d32', icon: '💵' },
    { label: 'Pending Refunds', value: '18', color: '#ed6c02', icon: '⏳' },
    { label: 'Failed Refunds', value: '6', color: '#d32f2f', icon: '⚠️' },
];

const refundRows = [
    {
        id: 1,
        ref: 'RFD-10234',
        originalTxn: 'TXN-56789',
        channel: 'Web',
        busNo: 'NB 2356',
        scheduleNo: '321654',
        depot: 'UM',
        breakdownPoint: 'Matara',
        depotConfirmation: 'OM',
        customer: 'Nimal Perera',
        bankCard: '****1234',
        cardColor: '#2e7d32',
        fareRefund: 'LKR 850.00',
        feeRefund: 'LKR 50.00',
        totalRefund: 'LKR 900.00',
        status: 'Requested',
        mode: 'Web'
    },
    {
        id: 2,
        ref: 'RFD-10230',
        originalTxn: 'TXN-57695',
        channel: 'Web',
        busNo: 'NC 4587',
        scheduleNo: '654321',
        depot: 'UM',
        breakdownPoint: 'Matara',
        depotConfirmation: 'OM',
        customer: 'Kasun Silva',
        bankCard: '****5678',
        cardColor: '#1976d2',
        fareRefund: 'LKR 100.00',
        feeRefund: 'LKR 10.00',
        totalRefund: 'LKR 110.00',
        status: 'Approved',
        mode: 'Web'
    },
    {
        id: 3,
        ref: 'RFD-10266',
        originalTxn: 'TXN-56774',
        channel: 'Web',
        busNo: 'ND 7741',
        scheduleNo: '741258',
        depot: 'UM',
        breakdownPoint: 'Matara',
        depotConfirmation: 'OM',
        customer: 'Chamodi Fernando',
        bankCard: '****1122',
        cardColor: '#5c35a0',
        fareRefund: 'LKR 850.00',
        feeRefund: 'LKR 50.00',
        totalRefund: 'LKR 900.00',
        status: 'Sent to Bank',
        mode: 'Web'
    },
    {
        id: 4,
        ref: 'RFD-10272',
        originalTxn: 'TXN-66793',
        channel: 'Mobile',
        busNo: 'NA 9981',
        scheduleNo: '852456',
        depot: 'UM',
        breakdownPoint: 'Matara',
        depotConfirmation: 'OM',
        customer: 'Tharindu Jayasuriya',
        bankCard: '****7788',
        cardColor: '#1976d2',
        fareRefund: 'LKR 860.00',
        feeRefund: 'LKR 50.00',
        totalRefund: 'LKR 910.00',
        status: 'Completed',
        mode: 'Mobile'
    },
    {
        id: 5,
        ref: 'RFD-10233',
        originalTxn: 'TXN-53253',
        channel: 'Web',
        busNo: 'NE 4432',
        scheduleNo: '963258',
        depot: 'UM',
        breakdownPoint: 'Matara',
        depotConfirmation: 'OM',
        customer: 'Dilani Wickramasinghe',
        bankCard: '****4455',
        cardColor: '#1976d2',
        fareRefund: 'LKR 800.00',
        feeRefund: 'LKR 100.00',
        totalRefund: 'LKR 900.00',
        status: 'Approved',
        mode: 'Web'
    },
    {
        id: 6,
        ref: 'RFD-10240',
        originalTxn: 'TXN-56791',
        channel: 'Mobile',
        busNo: 'NF 6677',
        scheduleNo: '789456',
        depot: 'UM',
        breakdownPoint: 'Matara',
        depotConfirmation: 'OM',
        customer: 'Sajith Kumara',
        bankCard: '****8899',
        cardColor: '#5c35a0',
        fareRefund: 'LKR 850.00',
        feeRefund: 'LKR 50.00',
        totalRefund: 'LKR 900.00',
        status: 'Sent to Bank',
        mode: 'Mobile'
    },
    {
        id: 7,
        ref: 'RFD-10245',
        originalTxn: 'TXN-44270',
        channel: 'Web',
        busNo: 'NG 5521',
        scheduleNo: '159357',
        depot: 'UM',
        breakdownPoint: 'Matara',
        depotConfirmation: 'OM',
        customer: 'Ravindu Senanayake',
        bankCard: '****2233',
        cardColor: '#1976d2',
        fareRefund: 'LKR 850.00',
        feeRefund: 'LKR 50.00',
        totalRefund: 'LKR 900.00',
        status: 'Completed',
        mode: 'Web'
    },
    {
        id: 8,
        ref: 'RFD-10280',
        originalTxn: 'TXN-56959',
        channel: 'Web',
        busNo: 'NH 1102',
        scheduleNo: '456123',
        depot: 'UM',
        breakdownPoint: 'Matara',
        depotConfirmation: 'OM',
        customer: 'Ishara Madushani',
        bankCard: '****3344',
        cardColor: '#2e7d32',
        fareRefund: 'LKR 850.00',
        feeRefund: 'LKR 50.00',
        totalRefund: 'LKR 900.00',
        status: 'Failed',
        mode: 'Web'
    },
    {
        id: 9,
        ref: 'RFD-10186',
        originalTxn: 'TXN-38135',
        channel: 'Web',
        busNo: 'NJ 7788',
        scheduleNo: '741963',
        depot: 'UM',
        breakdownPoint: 'Matara',
        depotConfirmation: 'OM',
        customer: 'Lakmal Rodrigo',
        bankCard: '****5566',
        cardColor: '#ed6c02',
        fareRefund: 'LKR 960.00',
        feeRefund: 'LKR 50.00',
        totalRefund: 'LKR 1,010.00',
        status: 'Failed',
        mode: 'Web'
    },
];
// ─── Status chip ──────────────────────────────────────────────────────────────

const StatusChip = ({ status }) => {
    const map = {
        'Requested': '#ed6c02',
        'Approved': '#1976d2',
        'Sent to Bank': '#5c35a0',
        'Completed': '#2e7d32',
        'Failed': '#d32f2f',
    };
    return (
        <Chip label={status} size="small"
            sx={{ backgroundColor: map[status] || '#999', color: '#fff', fontWeight: 600, fontSize: 11, minWidth: 85 }} />
    );
};

// ─── Pagination hook ──────────────────────────────────────────────────────────

const usePagination = (defaultRows = 10) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(defaultRows);
    return {
        page, rowsPerPage,
        handleChangePage: (_, p) => setPage(p),
        handleChangeRowsPerPage: (e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); },
        startIndex: page * rowsPerPage,
    };
};

// ─── Component ────────────────────────────────────────────────────────────────

const RefundRegisterPage = () => {

    // Filters
    const [dateRange, setDateRange] = useState('');
    const [refundStatus, setRefundStatus] = useState('');
    const [channel, setChannel] = useState('');
    const [refundMode, setRefundMode] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [refundRefNo, setRefundRefNo] = useState('');

    // Detail modal
    const [detailOpen, setDetailOpen] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);
    const handleDetailOpen = (row) => { setCurrentRow(row); setDetailOpen(true); };
    const handleDetailClose = () => { setCurrentRow(null); setDetailOpen(false); };

    // Pagination
    const pag = usePagination();

    // Shared cell styles — same as sample code
    const thSx = { py: 1 };
    const tdSx = { py: 0 };

    return (
        <Container component="main" maxWidth="full" sx={{ py: 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>

                {/* ── Page Title ── */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 3, flexWrap: 'wrap', gap: 2 }}>
                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                        Refund Register
                    </Typography>
                    <IconButton size="small"><MoreHorizIcon /></IconButton>
                </Box>

                <Box sx={{ width: '100%', overflow: 'hidden' }}>
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        {summaryCards.map((card) => (
                            <Grid item xs={12} sm={6} md={3} key={card.label}>
                                <Paper
                                    variant="outlined"
                                    sx={{
                                        p: 2,
                                        borderRadius: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 2,
                                        height: '100%',
                                    }}
                                >
                                    <Typography sx={{ fontSize: 26 }}>{card.icon}</Typography>
                                    <Box>
                                        <Typography variant="body2" color="text.secondary">
                                            {card.label}
                                        </Typography>
                                        <Typography
                                            variant="h6"
                                            sx={{ fontWeight: 700, color: card.color }}
                                        >
                                            {card.value}
                                        </Typography>
                                    </Box>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

                {/* ── Filter Bar ── */}
                <Box sx={{ width: '100%', mb: 1 }}>
                    <Grid container spacing={1}>

                        <Grid item xs={12} sm={6} md={3} lg={2}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Date Range</InputLabel>
                                <Select value={dateRange} onChange={e => setDateRange(e.target.value)} label="Date Range">
                                    <MenuItem value="today">Today</MenuItem>
                                    <MenuItem value="this_week">This Week</MenuItem>
                                    <MenuItem value="this_month">This Month</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3} lg={2}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Refund Status</InputLabel>
                                <Select value={refundStatus} onChange={e => setRefundStatus(e.target.value)} label="Refund Status">
                                    <MenuItem value="requested">Requested</MenuItem>
                                    <MenuItem value="approved">Approved</MenuItem>
                                    <MenuItem value="sent_to_bank">Sent to Bank</MenuItem>
                                    <MenuItem value="completed">Completed</MenuItem>
                                    <MenuItem value="failed">Failed</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3} lg={2}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Channel</InputLabel>
                                <Select value={channel} onChange={e => setChannel(e.target.value)} label="Channel">
                                    <MenuItem value="web">Web</MenuItem>
                                    <MenuItem value="mobile">Mobile</MenuItem>
                                    <MenuItem value="travel_card">Travel Card</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3} lg={2}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Refund Mode</InputLabel>
                                <Select value={refundMode} onChange={e => setRefundMode(e.target.value)} label="Refund Mode">
                                    <MenuItem value="bank">Bank</MenuItem>
                                    <MenuItem value="card">Card</MenuItem>
                                    <MenuItem value="wallet">Wallet</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3} lg={2}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Customer Name"
                                value={customerName}
                                onChange={e => setCustomerName(e.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3} lg={2}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Refund Ref No"
                                value={refundRefNo}
                                onChange={e => setRefundRefNo(e.target.value)}
                            />
                        </Grid>

                    </Grid>
                </Box>

                {/* ── Action buttons row ── */}
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 3, alignItems: 'center', width: '100%', justifyContent: 'flex-end' }}>
                    <Button
                        variant="contained"
                        sx={{ padding: '6px 24px', fontWeight: 'bold', borderRadius: '4px', height: '40px', backgroundColor: '#3f51b5', color: '#fff', '&:hover': { backgroundColor: '#303f9f' } }}
                    >
                        Apply Filters
                    </Button>
                    <Button variant="outlined" startIcon={<RefreshIcon />}
                        sx={{ fontWeight: 'bold', borderRadius: '4px', height: '40px', textTransform: 'none' }}>
                        Reset
                    </Button>
                    <Button variant="outlined" startIcon={<DownloadIcon />}
                        sx={{ fontWeight: 'bold', borderRadius: '4px', height: '40px', textTransform: 'none' }}>
                        Export
                    </Button>
                    <IconButton size="small"><MoreHorizIcon /></IconButton>
                </Box>

                {/* ── Table Title ── */}
                <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    {/* <TableChartIcon sx={{ color: '#1976d2', fontSize: 20 }} /> */}
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>OnlineRefund Register</Typography>
                </Box>

                {/* ══════════════════════════════════════════
                    TABLE — Refund Register
                ══════════════════════════════════════════ */}
                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                <TableCell sx={thSx}>Refund Ref No</TableCell>
                                <TableCell sx={thSx}>Original Txn Ref</TableCell>
                                <TableCell sx={thSx}>Channel</TableCell>
                                <TableCell sx={thSx}>Bus No</TableCell>
                                {/* <TableCell sx={thSx}>Schedule No</TableCell> */}
                                <TableCell sx={thSx}>Depot</TableCell>
                                <TableCell sx={thSx}>Breakdown Point</TableCell>
                                <TableCell sx={thSx}>Depot Confirmation</TableCell>
                                <TableCell sx={thSx}>Customer Name</TableCell>
                                <TableCell sx={thSx}>Bank/Card Ref</TableCell>
                                <TableCell sx={thSx}>Fare Refund</TableCell>
                                <TableCell sx={thSx}>Fee Refund</TableCell>
                                <TableCell sx={thSx}>Total Refund</TableCell>
                                <TableCell sx={thSx}>Refund Status</TableCell>
                                <TableCell sx={thSx}>Mode</TableCell>
                                <TableCell sx={thSx}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {refundRows
                                .slice(pag.startIndex, pag.startIndex + pag.rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell sx={tdSx}>
                                            <Typography variant="body2"
                                                sx={{ color: '#1976d2', cursor: 'pointer', fontWeight: 600, '&:hover': { textDecoration: 'underline' } }}
                                                onClick={() => handleDetailOpen(row)}>
                                                {row.ref}
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={tdSx}>{row.originalTxn}</TableCell>
                                        <TableCell sx={tdSx}>{row.channel}</TableCell>
                                        <TableCell sx={tdSx}>{row.busNo}</TableCell>
                                        {/* <TableCell sx={tdSx}>{row.scheduleNo}</TableCell> */}
                                        <TableCell sx={tdSx}>{row.depot}</TableCell>
                                        <TableCell sx={tdSx}>{row.breakdownPoint}</TableCell>
                                        <TableCell sx={tdSx}>{row.depotConfirmation}</TableCell>
                                        <TableCell sx={tdSx}>{row.customer}</TableCell>
                                        <TableCell sx={tdSx}>
                                            <Chip label={row.bankCard} size="small"
                                                sx={{ backgroundColor: row.cardColor, color: '#fff', fontWeight: 700, fontSize: 11 }} />
                                        </TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.fareRefund}</TableCell>
                                        <TableCell sx={tdSx}>{row.feeRefund}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.totalRefund}</TableCell>
                                        <TableCell sx={tdSx}>
                                            <StatusChip status={row.status} />
                                        </TableCell>
                                        <TableCell sx={tdSx}>{row.mode}</TableCell>
                                        <TableCell sx={tdSx}>
                                            <Button size="small" endIcon={<KeyboardArrowDownIcon />}
                                                sx={{ minWidth: 0, p: '2px 6px', borderRadius: '4px', border: '1px solid #ccc', color: '#555', textTransform: 'none' }}>
                                                •••
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={refundRows.length}
                        page={pag.page}
                        onPageChange={pag.handleChangePage}
                        rowsPerPage={pag.rowsPerPage}
                        onRowsPerPageChange={pag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </TableContainer>

                {/* ══════════════════════════════════════════
                    Detail Modal — same style as sample
                ══════════════════════════════════════════ */}
                <Modal open={detailOpen} onClose={handleDetailClose}>
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90%',
                        maxWidth: 560,
                        bgcolor: 'background.paper',
                        border: '2px solid gray',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: '10px',
                    }}>
                        <Typography variant="h6" gutterBottom>
                            Refund Detail — {currentRow?.ref}
                        </Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Original Txn Ref" value={currentRow?.originalTxn || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Channel" value={currentRow?.channel || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Customer Name" value={currentRow?.customer || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Bank / Card Ref" value={currentRow?.bankCard || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Fare Refund" value={currentRow?.fareRefund || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Fee Refund" value={currentRow?.feeRefund || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Total Refund" value={currentRow?.totalRefund || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Refund Status" value={currentRow?.status || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth multiline rows={3} size="small" label="Notes" placeholder="Enter notes..." />
                            </Grid>
                        </Grid>

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                            <Button variant="contained" color="primary" onClick={handleDetailClose} sx={{ marginRight: '8px' }}>
                                Save
                            </Button>
                            <Button variant="contained" onClick={handleDetailClose} sx={{ backgroundColor: 'gray' }}>
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Modal>

            </Box>
        </Container>
    );
};

export default RefundRegisterPage;